/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  AppBar,
  Toolbar,
  IconButton,
  CircularProgress,
  Badge,
} from '@material-ui/core';
import { Redeem, ShoppingCart } from '@material-ui/icons';
import React, { FC } from 'react';

import styled from 'styled-components';

const StyledAppbar = styled.div`
  flex-grow: 1;
`;

const StyledTitle = styled.div`
  flex-grow: 1;
  text-align: center;
  font-size: 1.6rem;

  @media screen and (max-width: 751px) {
    font-size: 0.6rem;
    font-weight: bold;
  }
`;

export type Props = {
  /**
   * ローディング中であるかを示す真偽値
   */
  isLoading: boolean;

  /**
   * カートボタンのバッジに表示する商品数
   */
  itemCount: number;

  /**
   * 商品ボタンをクリックした時に実行される関数
   */
  productButtonOnClickFunction: VoidFunction;

  /**
   * カートボタンをクリックした時に実行される関数
   */
  cartButtonOnClickFunction: VoidFunction;
};

const SalesArea: FC<Props> = ({
  isLoading,
  itemCount,
  productButtonOnClickFunction,
  cartButtonOnClickFunction,
  children,
}) => {
  return (
    <>
      {isLoading ? (
        <CircularProgress />
      ) : (
        <>
          <StyledAppbar>
            <AppBar position="static">
              <Toolbar>
                <StyledTitle>
                  新型コロナに負けるな！買って応援 北海道
                </StyledTitle>
                <IconButton onClick={() => productButtonOnClickFunction()}>
                  <Redeem style={{ color: 'fff' }} />
                </IconButton>
                <IconButton onClick={() => cartButtonOnClickFunction()}>
                  <Badge badgeContent={itemCount} max={99} color="secondary">
                    <ShoppingCart style={{ color: 'fff' }} />
                  </Badge>
                </IconButton>
              </Toolbar>
            </AppBar>
          </StyledAppbar>
          {children}
        </>
      )}
    </>
  );
};

export default SalesArea;
